<script>
import { Bar } from "vue-chartjs";
import { API } from "@/api.js";
import { COLORS } from "@/components/colors.js";

export default {
  extends: Bar,
  data: () => ({
    chartdata: null,
    options: null,
  }),
  props: {
    mcode: String,
  },
  async mounted() {
    this.chartdata = {
      labels: [],
      datasets: [
        {
          label: "Paying",
          backgroundColor: COLORS.Tableau20[0],
          data: [],
            barPercentage: 1,
            categoryPercentage: 0.5,
        },
        {
          label: "Free",
          backgroundColor: COLORS.Tableau20[1],
          data: [],
            barPercentage: 1,
            categoryPercentage: 0.5,
        },
        {
          label: "Included",
          backgroundColor: COLORS.Tableau20[2],
          data: [],
            barPercentage: 1,
            categoryPercentage: 0.5,
        },
      ],
    }
    this.options = {
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: true,
        position: "right",
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
      // radius: 20,
      // clip: 1,
      // backgroundColor: 'rgba(0.2, 0.4, 0.6, 0.1)'
    }
    let data = await API.totalAssistanceHoursByType(this.mcode);
    this.chartdata.labels = data.map((d) => d.machine);
    // rendo le labels uniche
    this.chartdata.labels = this.chartdata.labels.filter(
      (item, pos, a) => a.indexOf(item) == pos
    );
    for(let ds of this.chartdata.datasets) {
        ds.data = []
        for(let m of this.chartdata.labels) {
            let d = data.find(d => d.machine == m && d.tipo == ds.label)
            if(d) {
                ds.data.push(d.ore)
            } else {
                ds.data.push(0)
            }
        }
    }
    try {
        this.renderChart(this.chartdata, this.options);
    } catch(e){
        // banale errore fake
    }
  },
};
</script>
<style>
</style>
